import { InjectionToken } from '@angular/core';
import { IGoogleAuthWarningStorageService } from '@app/models/objects/google-auth-warning-storage.model';

export const GOOGLE_AUTH_WARNING_STORAGE =
  new InjectionToken<IGoogleAuthWarningStorageService>(
    'GOOGLE_AUTH_WARNING_STORAGE',
  );
